import { requestType } from '~/config/enum.config';
var SERVICE = 'common-service';
var CONTROLLER = 'dataPoolController';
export default {
    /**
     * 获取特殊数据字典
     */
    getDataPools: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getDataPools',
        type: requestType.Get
    },
};
